import style from './CardSettingsPage.css';
import { useEffect, useRef, useState } from 'preact/hooks';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import AppBar from '../../components/shared/AppBar/AppBar';
import ListingSkeleton from '../../components/shared/ListingSkeleton/ListingSkeleton';
import useTranslation from '../../localization/i18n.context';
import CardSettingsView from './CardSettingsView';
import CardService from '../../services/card.service';
import NavigationUtils from '../../utils/navigation.utils';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function CardSettingsPage({ popup, organization, cardUid }) {
  const backRef = useRef(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});

  const handleBackClick = () => {
    NavigationUtils.back();
  };

  useAndroidBackPress(backRef.current, () => {
    if (window.location.search.includes('popup')) {
      history.back();
    } else {
      backRef.current.props.onClick();
    }
  });

  useEffect(() => {
    CardService.getSettings(organization)
      .then(({ data }) => {
        setLoading(false);
        setSettings(data);
        TrackingEvent.trigger(
          TrackingEvent.Events.CARD_SETTING_SCREEN_SHOW,
          TrackingEvent.Sources.CAAS,
        );
      })
      .catch(() => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  return (
    <>
      <AppBar
        onBackClick={handleBackClick}
        title={t('Card settings')}
        className="fixed-bar"
        backRef={backRef}
      />

      <div className={style.container}>
        {loading ? (
          <ListingSkeleton className={style.main} />
        ) : (
          <CardSettingsView
            popupType={popup}
            settings={settings}
            organization={organization}
          />
        )}
      </div>
    </>
  );
}
